import { Stack } from '@mui/material';
import { IFilteredCategories } from '..';
import { SelectedFilter } from './SelectedFilter';

interface IFilters {
  filteredCategories: IFilteredCategories[];
}

export const Filters = ({ filteredCategories }: IFilters) => {
  return (
    <Stack direction='row' gap='12px' flexWrap='wrap'>
      {filteredCategories.map((category: IFilteredCategories) => {
        if (category.id === 0) return null;
        return (
          <SelectedFilter
            key={category.mainCategory + category.id}
            id={category.id}
            name={category.name}
            mainCategory={{
              id: category.mainCategoryID,
              name: category.mainCategory,
            }}
          />
        );
      })}
    </Stack>
  );
};
